import React from 'react';
import { CTAButton } from './CTAButton';
import { Check } from 'lucide-react';
export const HeroSection: React.FC = () => {
  return <section className="relative bg-gradient-to-b from-orange-50 to-white pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-30">
      <div className="max-w-7xl mx-auto" data-id="element-31">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 items-center" data-id="element-32">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left" data-id="element-33">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-orange-100 text-orange-800 text-xs font-medium mb-6" data-id="element-34">
              Acceso inmediato • Descarga digital • Organizado por unidades
            </div>
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl" data-id="element-35">
              <span className="block xl:inline" data-id="element-36">MegaPack Música Lista</span>{' '}
              <span className="block text-orange-600" data-id="element-37">
                Material imprimible + clases listas
              </span>
            </h1>
            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0" data-id="element-38">
              Música lista para todo el año (sin perder horas preparando
              clases). Actividades, juegos, fichas y evaluaciones listas para
              usar.
            </p>

            <div className="mt-6 space-y-2" data-id="element-39">
              {['Planificación anual + por unidades', 'Actividades listas (ritmo, melodía, audición)', 'Juegos musicales para enganchar', 'Fichas imprimibles listas', 'Evaluaciones simples + rúbricas'].map((item, i) => <div key={i} className="flex items-center sm:justify-center lg:justify-start" data-id="element-40">
                  <Check className="h-5 w-5 text-green-500 mr-2" data-id="element-41" />
                  <span className="text-gray-700" data-id="element-42">{item}</span>
                </div>)}
            </div>

            <div className="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0" data-id="element-43">
              <CTAButton text="👉 Quiero acceder al MegaPack" data-id="element-44" />
              <p className="mt-3 text-sm text-gray-400" data-id="element-45">
                Acceso inmediato – descarga digital al finalizar la compra
              </p>
            </div>
          </div>
          <div className="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center" data-id="element-46">
            <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md" data-id="element-47">
              <div className="relative block w-full bg-white rounded-lg overflow-hidden" data-id="element-48">
                <img className="w-full" src="https://cdn.magicpatterns.com/uploads/wTDMwXfAxHJB65BXCxvMoJ/cover.png" alt="MegaPack Música Lista Cover" data-id="element-49" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};